import * as React from "react"
import { useState, useEffect } from "react"
import { Box, Button, Grid, Typography } from "@mui/material"
import { useDropzone } from "react-dropzone"
import { CircularProgress } from "@mui/material"
import { useNavigate } from "react-router-dom"
import CameraAltIcon from "@mui/icons-material/CameraAlt"
import { downscale, dataURLToBlob } from "../../utils/imageFunctions"
import "react-html5-camera-photo/build/css/index.css"
import Images from "../../components/home/Images"
import ImageIcon from "@mui/icons-material/Image"
import RepresentativeImage from "./RepresentativeImage"
import { Slider } from "@mui/material"
import { useQuery, useQueryClient } from "react-query"

async function fetchRepresentativeImages() {
  const res = await fetch(
    `${
      process.env.REACT_APP_API_BASE_URL || ""
    }/api/admin/get-representative-images`,
    { credentials: "include" }
  )
  if (!res.ok) {
    throw new Error("Network response was not ok")
  }
  return res.json()
}

function KeypointTab() {
  const [state, setState] = useState({
    imageUrls: [],
    maskUrls: [],
    imageNames: [],
    keypoints1: [],
    keypoints2: [],
    matches: [],
    corners: [],
    selectedImageIndex: 0,
  })

  const [threshold, setThreshold] = useState(0.75)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { data, status } = useQuery(
    "representativeImage",
    fetchRepresentativeImages,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  )

  useEffect(() => {
    console.info("IN USE EFFECT")
    if (!data) return
    console.info("HAS DATA")
    const encodedImages = data.train_images
    const decodedImages = encodedImages.map((encodedImage) => {
      return `data:image/jpg;base64,${encodedImage}`
    })
    const encodedMasks = data.train_image_masks
    const decodedMasks = encodedMasks.map((encodedImage) => {
      return `data:image/png;base64,${encodedImage}`
    })
    const corners = data.train_image_corners
    console.info("BEFORE SET STATE")
    setState({
      ...state,
      imageUrls: decodedImages,
      maskUrls: decodedMasks,
      imageNames: data.train_image_names,
      corners,
    })
    console.info("FINISHED USE EFFECT")
  }, [data])

  if (status === "loading") {
    return <div>Loading...</div>
  }

  if (status === "error") {
    return <div>Error fetching data</div>
  }

  const handleDelete = async () => {
    const formData = new FormData()
    formData.append(
      "train_image_name",
      state.imageNames[state.selectedImageIndex]
    )
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_BASE_URL || ""
        }/api/admin/delete-representative-image`,
        {
          method: "POST",
          credentials: "include",
          body: formData,
        }
      )
      const json = await response.json()
      console.info(json)
      // expire the query
      queryClient.invalidateQueries("representativeImage")
    } catch (error) {
      console.error("Error deleting image: ", error)
    }
  }

  console.info("DATA: ", data)

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          {state.imageUrls.map((imageUrl, index) => {
            const isSelected = state.selectedImageIndex === index
            return (
              <Button
                key={index}
                onClick={() =>
                  setState({ ...state, selectedImageIndex: index })
                }
                style={{
                  flexDirection: "column",
                  border: isSelected ? "1px solid black" : "1px solid white",
                }}
              >
                <img
                  src={imageUrl}
                  style={{ width: "100px", height: "100px" }}
                />
                <div>{state.imageNames[index]}</div>
              </Button>
            )
          })}
        </Grid>
        <Grid item xs={12} md={12}>
          <Button onClick={handleDelete}>
            <Typography>Delete Image</Typography>
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          {loading ? (
            <CircularProgress />
          ) : (
            <RepresentativeImage
              imageUrl={state?.imageUrls[state?.selectedImageIndex]}
              keypoints1={state?.keypoints1}
              keypoints2={state?.keypoints2}
              matches={state?.matches}
              img1Shape={state?.img1Shape}
              matchesMask={state?.matchesMask}
              corners={state?.corners[state?.selectedImageIndex]}
              maskImageUrl={state?.maskUrls[state?.selectedImageIndex]}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default KeypointTab
